import React, { FunctionComponent } from 'react'
import { Navigate } from 'react-router'

import { RetrieveConfig } from '../../state/configuration'
import { AppPath } from '../AppPath'
import { AnonymousPrincipal } from '../authentication'
import { RetrievePage } from './RetrievePage'
import { RetrieveToken } from './RetrieveToken'

export interface RetrieveFactoryProps {
  principal: AnonymousPrincipal
  config: RetrieveConfig
}

export const RetrieveFactory: FunctionComponent<RetrieveFactoryProps> = ({
  config,
  principal,
}) => {
  switch (config.type) {
    case 'form':
      return <RetrievePage principal={principal} />
    case 'token':
      return <RetrieveToken principal={principal} />
    default:
      return <Navigate to={AppPath.HOME} />
  }
}
